// extracted by mini-css-extract-plugin
export default {"SiteDarkGrey":"#5A6268","Footer":"Footer_Footer__6gYD2","active":"Footer_active__8mZYg","MadeIn":"Footer_MadeIn__WrTRN","Link":"Footer_Link__ofHC9"};